import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorTranslatedComponent } from '@campaign-management/app/components/molecules/mat-paginator-translated/mat-paginator-translated.component';
import { OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { TableColumnAnomalyComponent } from '@dice/app/components/atoms/table-columns/table-column-anomaly/table-column-anomaly.component';
import { TableColumnAnomalyDetailComponent } from '@dice/app/components/atoms/table-columns/table-column-anomaly-detail/table-column-anomaly-detail.component';
import { TableColumnBooleanComponent } from '@dice/app/components/atoms/table-columns/table-column-boolean/table-column-boolean.component';
import { TableColumnButtonComponent } from '@dice/app/components/atoms/table-columns/table-column-button/table-column-button.component';
import { TableColumnCheckboxComponent } from '@dice/app/components/atoms/table-columns/table-column-checkbox/table-column-checkbox.component';
import { TableColumnCheckbox2Component } from '@dice/app/components/atoms/table-columns/table-column-checkbox2/table-column-checkbox2.component';
import { TableColumnDropDownComponent } from '@dice/app/components/atoms/table-columns/table-column-drop-down/table-column-drop-down.component';
import { TableColumnFlyoutMenuComponent } from '@dice/app/components/atoms/table-columns/table-column-flyout-menu/table-column-flyout-menu.component';
import { TableColumnIconComponent } from '@dice/app/components/atoms/table-columns/table-column-icon/table-column-icon.component';
import { TableColumnImgComponent } from '@dice/app/components/atoms/table-columns/table-column-img/table-column-img.component';
import { TableColumnLinkComponent } from '@dice/app/components/atoms/table-columns/table-column-link/table-column-link.component';
import { TableColumnNgTemplateComponent } from '@dice/app/components/atoms/table-columns/table-column-ng-template/table-column-ng-template.component';
import { OpenhourScenarioComponent } from '@dice/app/components/atoms/table-columns/table-column-openhour-detail/openhour-scenario/openhour-scenario.component';
import { ScenarioAttributeIdentifierComponent } from '@dice/app/components/atoms/table-columns/table-column-openhour-detail/openhour-scenario/scenario-attribute-identifier/scenario-attribute-identifier.component';
import { ScenarioAttributeRangeComponent } from '@dice/app/components/atoms/table-columns/table-column-openhour-detail/openhour-scenario/scenario-attribute-range/scenario-attribute-range.component';
import { ScenarioAttributeStateComponent } from '@dice/app/components/atoms/table-columns/table-column-openhour-detail/openhour-scenario/scenario-attribute-state/scenario-attribute-state.component';
import { TableColumnOpenhourDetailComponent } from '@dice/app/components/atoms/table-columns/table-column-openhour-detail/table-column-openhour-detail.component';
import { TableColumnPrerenderedTextComponent } from '@dice/app/components/atoms/table-columns/table-column-prerendered-text/table-column-prerendered-text.component';
import { TableColumnRadioButtonComponent } from '@dice/app/components/atoms/table-columns/table-column-radio-button/table-column-radio-button.component';
import { TableColumnRolesComponent } from '@dice/app/components/atoms/table-columns/table-column-roles/table-column-roles.component';
import { TableColumnSwitchComponent } from '@dice/app/components/atoms/table-columns/table-column-switch/table-column-switch.component';
import { TableColumnTextComponent } from '@dice/app/components/atoms/table-columns/table-column-text/table-column-text.component';
import { TableButtonsGroupComponent } from '@dice/app/components/molecules/table-buttons-group/table-buttons-group.component';
import { TableColumnComponent } from '@dice/app/components/molecules/table-column/table-column.component';
import { TableHeaderComponent } from '@dice/app/components/molecules/table-header/table-header.component';
import { MatMultiSortModule } from '@dice/app/components/organisms/mat-multi-sort/mat-multi-sort.module';
import { MultisortTableComponent } from '@dice/app/components/organisms/multisort-table/multisort-table.component';
import { TableComponent } from '@dice/app/components/organisms/table/table.component';
import { VirtualScrollTableComponent } from '@dice/app/components/organisms/virtual-scroll-table/virtual-scroll-table.component';
import { TableFilterDirective } from '@dice/app/directives/table-filter.directive';
import { TableSortDirective } from '@dice/app/directives/table-sort.directive';
import { CoreTableVirtualScrollModule } from '@dice/app/libraries/core-table-virtual-scrolling/virtual-scroll/virtual-scroll.module';
import { AngularMaterialModule } from '@dice/app/shared-components/angular-material.module';
import { CommonComponentsModule } from '@dice/app/shared-components/common-components.module';
import { AuditInfoComponent } from '@dice/app/shared-components/molecules/audit-info/audit-info.component';
import { InArrayPipe } from '@home/app/pipes/in-array.pipe';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    TableSortDirective,
    TableFilterDirective,
    TableComponent,
    MultisortTableComponent,
    TableColumnComponent,
    TableColumnButtonComponent,
    TableColumnTextComponent,
    TableColumnPrerenderedTextComponent,
    TableColumnImgComponent,
    TableColumnLinkComponent,
    TableColumnRolesComponent,
    TableHeaderComponent,
    TableButtonsGroupComponent,
    TableColumnFlyoutMenuComponent,
    InArrayPipe,
    TableColumnCheckboxComponent,
    TableColumnCheckbox2Component,
    TableColumnRadioButtonComponent,
    TableColumnSwitchComponent,
    TableColumnDropDownComponent,
    VirtualScrollTableComponent,
    TableColumnAnomalyComponent,
    TableColumnAnomalyDetailComponent,
    TableColumnOpenhourDetailComponent,
    OpenhourScenarioComponent,
    ScenarioAttributeIdentifierComponent,
    ScenarioAttributeRangeComponent,
    ScenarioAttributeStateComponent,
    TableColumnIconComponent,
    AuditInfoComponent,
    TableColumnNgTemplateComponent,
    TableColumnBooleanComponent,
  ],
  exports: [
    TableComponent,
    MultisortTableComponent,
    TableColumnComponent,
    TableColumnButtonComponent,
    TableColumnTextComponent,
    TableColumnPrerenderedTextComponent,
    TableColumnRolesComponent,
    TableHeaderComponent,
    TableButtonsGroupComponent,
    TableColumnCheckboxComponent,
    TableColumnCheckbox2Component,
    TableColumnSwitchComponent,
    TableColumnRadioButtonComponent,
    TableColumnDropDownComponent,
    VirtualScrollTableComponent,
    CoreTableVirtualScrollModule,
    TableColumnIconComponent,
    TableSortDirective,
    TableFilterDirective,
    OpenhourScenarioComponent,
    ScenarioAttributeIdentifierComponent,
    ScenarioAttributeRangeComponent,
    ScenarioAttributeStateComponent,
  ],
  imports: [
    CommonComponentsModule,
    TranslateModule,
    CommonModule,
    ObserversModule,
    AngularMaterialModule,
    OwlDateTimeModule,
    CoreTableVirtualScrollModule,
    MatMultiSortModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [DatePipe, { provide: MatPaginatorIntl, useClass: MatPaginatorTranslatedComponent }],
})
export class TableComponentsModule {}
